
import React from "react";
import { Classname } from "@rivtn/noseur";
import { useInView } from "../../hooks";
import styles from "../../assets/style.module.css";

export interface QuoteProps {
    quote: string;
    author: string;
}

function Quote({ quote, author }: QuoteProps) {

    const [ref, inView] = useInView();

    return (<div ref={ref} className={Classname.build(styles["quote"], styles["reveal"], { [styles["in-view"]]: inView })}>
        <div className={styles["container"]}>
            <div className={styles["quote-mark"]}>"</div>
            <blockquote className={styles["quote-text"]}>{quote}</blockquote>
            <p className={styles["quote-author"]}>— {author}</p>
        </div>
    </div>);
}

export default Quote;
